enum InputError {
    Required,
    InvalidEmail,
    NoMatch,
    InvalidPassword,
    Decimal,
}

export default InputError;
